/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DocumentId
 */
export interface DocumentId {
    /**
     * 
     * @type {string}
     * @memberof DocumentId
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentId
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentId
     */
    scheme?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentId
     */
    identifier?: string;
}

/**
 * Check if a given object implements the DocumentId interface.
 */
export function instanceOfDocumentId(value: object): value is DocumentId {
    return true;
}

export function DocumentIdFromJSON(json: any): DocumentId {
    return DocumentIdFromJSONTyped(json, false);
}

export function DocumentIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentId {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'id': json['id'] == null ? undefined : json['id'],
        'scheme': json['scheme'] == null ? undefined : json['scheme'],
        'identifier': json['identifier'] == null ? undefined : json['identifier'],
    };
}

export function DocumentIdToJSON(json: any): DocumentId {
    return DocumentIdToJSONTyped(json, false);
}

export function DocumentIdToJSONTyped(value?: DocumentId | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenantId': value['tenantId'],
        'id': value['id'],
        'scheme': value['scheme'],
        'identifier': value['identifier'],
    };
}

